export default __webpack_public_path__ + "static/media/7.8257f5b9.jpeg";